import { api } from '../api';
import { showGoodToast, showBadToast } from '../../errors/toast';
import {
    OrderHeader,
    OrderInfo,
    OrderBatchInfo,
    OrderStockItemInfo
} from '../../../models/Orders';
import logMessage from '../../errors/foutlog';

const actions = {
    // DateTime from, DateTime until
    async loadAssignedSalesOrderStockInfo(context, data) {
        let tempList = [];
        try {
            const res = await api.fetchAssignedSalesOrderStockInfo(data.data);
            tempList = res.data.Items.map((x) => new OrderStockItemInfo(x));
        } catch (error) {
            tempList = [];
            showBadToast(
                context,
                data.func('com_errorladen', {
                    ns: 'common',
                    val: data
                        .func('com_salesorders', { ns: 'common' })
                        .toLowerCase()
                }),
                error
            );
        }
        return tempList;
    },
    async assignSalesOrder(context, data) {
        try {
            await api.assignSalesOrder(data.data);
            showGoodToast(
                context,
                data.func('com_opgeslagen', {
                    ns: 'common',
                    val: data.func('com_assignment', { ns: 'common' })
                })
            );
        } catch (error) {
            showBadToast(
                context,
                data.func('com_erroropslaan', {
                    ns: 'common',
                    val: data.func('com_assignment', { ns: 'common' })
                }),
                error
            );
        }
    },

    // DateTime from, DateTime until
    async loadSalesOrderBatchInfo(context, data) {
        let tempList = [];
        try {
            const res = await api.fetchSalesOrderBatchInfo(data.data);
            tempList = res.data.Items.map((x) => new OrderBatchInfo(x));
        } catch (error) {
            tempList = [];
            showBadToast(
                context,
                data.func('com_errorladen', {
                    ns: 'common',
                    val: data
                        .func('com_salesorders', { ns: 'common' })
                        .toLowerCase()
                }),
                error
            );
        }
        return tempList;
    },

    // DateTime from, DateTime until
    async loadSalesOrderInfo(context, data) {
        let tempList = [];
        try {
            const res = await api.fetchSalesOrderInfo(data.data);
            tempList = res.data.Items.map((x) => new OrderInfo(x));
        } catch (error) {
            tempList = [];
            showBadToast(
                context,
                data.func('com_errorladen', {
                    ns: 'common',
                    val: data
                        .func('com_salesorders', { ns: 'common' })
                        .toLowerCase()
                }),
                error
            );
        }
        return tempList;
    },
    async loadSalesOrder(context, data) {
        let item = null;
        try {
            const res = await api.fetchSalesOrder(data.data);
            item = new OrderHeader(res.data);
        } catch (error) {
            showBadToast(
                context,
                data.func('com_errorladen', {
                    ns: 'common',
                    val: data
                        .func('com_salesorder', { ns: 'common' })
                        .toLowerCase()
                }),
                error
            );
        }
        return item;
    },
    async unlinkSalesOrderLine(context, data) {
        try {
            await api.unlinkSalesOrderLine(data.data);
        } catch (error) {
            showBadToast(
                context,
                data.func('com_errorverwijder', {
                    ns: 'common',
                    val: data.func('com_salesorderline', { ns: 'common' })
                }),
                error
            );
        }
    },
    async deleteSalesOrderLine(context, data) {
        try {
            await api.deleteSalesOrderLine(data.data);
            showGoodToast(
                context,
                data.func('com_verwijderd', {
                    ns: 'common',
                    val: data.func('com_salesorder', { ns: 'common' })
                })
            );
        } catch (error) {
            showBadToast(
                context,
                data.func('com_errorverwijder', {
                    ns: 'common',
                    val: data.func('com_salesorderline', { ns: 'common' })
                }),
                error
            );
        }
    },
    async saveSalesOrder(context, data) {
        try {
            await api.storeSalesOrder(data.data);
            showGoodToast(
                context,
                data.func('com_opgeslagen', {
                    ns: 'common',
                    val: data.func('com_salesorder', { ns: 'common' })
                })
            );
        } catch (error) {
            showBadToast(
                context,
                data.func('com_erroropslaan', {
                    ns: 'common',
                    val: data
                        .func('com_salesorder', { ns: 'common' })
                        .toLowerCase()
                }),
                error
            );
        }
    }
};

export default actions;

